import React from 'react';
import Translation from '../translation/translation';

function PostcodeLightBoxHeader() {
    return (
        <div className="postcode-light-box__header postcode-light-box-header">
            <Translation
                translationKey="postcode-light-box-header"
                className="postcode-light-box-header__headline"
            />
        </div>
    );
}

export { PostcodeLightBoxHeader };
